__turbopack_context__.v({
  "root": "MinimalFooter-module__vI157W__root",
});
